(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hmc-lab-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hmc-lab-viewer')) {
    customElements.define('hmc-lab-viewer', class extends HTMLElement {
      connectedCallback() {
        if (this._labReady) return;
        this._labReady = true;
        this.dialog = this.querySelector('dialog');
        this.preview = this.querySelector('.hmc-lab-viewer__preview');
        this.documentButton = this.querySelector('.hmc-lab-viewer__document');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.preview.setAttribute('role', 'button');
        this.preview.setAttribute('aria-haspopup', 'dialog');
        const openReport = event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.dialog.showModal();
        };
        this.preview.addEventListener('click', openReport);
        this.preview.addEventListener('keydown', event => {
          if (event.key === ' ') openReport(event);
        });
        this.querySelector('.hmc-lab-viewer__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.documentButton.setAttribute('aria-pressed', 'false');
          this.documentButton.setAttribute('aria-label', 'Zoom in on lab report');
          const body = this.querySelector('.hmc-lab-viewer__body');
          body.scrollTo(0, 0);
          if (this.preview.isConnected) this.preview.focus({ preventScroll: true });
        });
        this.documentButton.addEventListener('click', () => {
          const zoomed = this.documentButton.getAttribute('aria-pressed') !== 'true';
          this.documentButton.setAttribute('aria-pressed', String(zoomed));
          this.documentButton.setAttribute('aria-label', zoomed ? 'Fit lab report to panel' : 'Zoom in on lab report');
        });
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
